import React from "react";
import { Routes, Route } from "react-router-dom";

import UiDemo from "../components/_uiMocks/UiDemo";

// import MainWrapper from '../components/_uiMocks/MainWrapper';
import DashboardWrapper from "../components/_uiMocks/pages/dashboard/DashboardWrapper";
import LocationsWrapper from "../components/_uiMocks/pages/locations/Locations";
import CampaignWrapper from "../components/_uiMocks/pages/campaign/CampaignWrapper";
import CreateNewCampaign from "../components/_uiMocks/pages/campaign/CreateNewCampaign";
import { CreateMarcoms } from "../components/_uiMocks/pages/marcoms/CreateMarcoms";
import MarcomsWrapper from "../components/_uiMocks/pages/marcoms/MarcomsWrapper";
import { SignInWrapper } from "../components/_uiMocks/pages/auth/SignInWrapper";
import { LookupTableWrapper } from "../components/_uiMocks/pages/dataManagment/LookUpTableWrapper";

import MainWrapper from "../components/_uiMocks/MainWrapper";
import { CreateLookupTable } from "../components/_uiMocks/pages/dataManagment/CreateLookupTable";
import FactTableWrapper from "../components/_uiMocks/pages/dataManagment/FactTableWrapper";
import DataTableWrapper from "../components/_uiMocks/pages/dataManagment/DataUploadwrapper";
import CheckboxTreeWrapper from "../components/_uiMocks/_uiComponents/CheckboxTreeWrapper";
import HierarchyDataGrid from "../components/_uiMocks/_uiComponents/hierarchyDataGrid/HierarchyDataGrid";
import CreateNotificationTable from "../components/_uiMocks/pages/messageService/CreateNotificationTable";
import ManageNotificationWrapper from "../components/_uiMocks/pages/messageService/ManageNotificationWrapper";
import VoucherManagementWrapper from "../components/_uiMocks/pages/VoucherManagement/VoucherManagementWrapper";

import NewsFeedWrapper from "../components/_uiMocks/pages/newsFeed/NewsFeedWrapper";
import CreateNewsFeed from "../components/_uiMocks/pages/newsFeed/CreateNewsFeed";
import { PermissionsWrapper } from "../components/_uiMocks/pages/userManagement/PermissionsWrapper";
import { RolesWrapper } from "../components/_uiMocks/pages/userManagement/RolesWrapper";
import { CreateRoles } from "../components/_uiMocks/pages/userManagement/CreateRoles";
import { UsersWrapper } from "../components/_uiMocks/pages/userManagement/UsersWrapper";
import { CreateUsersWrapper } from "../components/_uiMocks/pages/userManagement/CreateUsersWrapper";
import { OtpVerifyWrapper } from "../components/_uiMocks/pages/auth/OtpVerifyWrapper";
import { ForgetPasswordWrapper } from "../components/_uiMocks/pages/auth/ForgetPasswordWrapper";
import ResetPasswordWrapper from "../components/_uiMocks/pages/auth/ResetPasswordWrapper";

export default function UiRoutes() {
     return (
          <Routes>
                <Route index element={<UiDemo />} />
               <Route path="/login" element={<SignInWrapper />} />
               <Route path="/dashboard" element={<DashboardWrapper />} />
               <Route path="/locations" element={<LocationsWrapper />} />
               <Route
                    path="/campaign-management"
                    element={<CampaignWrapper />}
               />
               <Route path="/create-new-campaign" element={<CreateNewCampaign />} />
               <Route path="/create-marcoms" element={<CreateMarcoms />} />
               <Route path="/manage-marcoms" element={<MarcomsWrapper />} />
               <Route path="/lookup-data-manage" element={<LookupTableWrapper />} />
               <Route path="/create-lookup-table" element={<CreateLookupTable />} />
               <Route path="/fact-data-manage" element={<FactTableWrapper />} />
               <Route path="/data-upload" element={<DataTableWrapper />} />

               <Route path="/checkbox-treeview" element={<CheckboxTreeWrapper />} />
               <Route path="/hierarchy-data-grid" element={<HierarchyDataGrid />} />
               <Route path="/message-service" element={<ManageNotificationWrapper />} />
               <Route path="/create-notification-table" element={<CreateNotificationTable />} />
               <Route path="/voucher-management" element={<VoucherManagementWrapper />} />
            
               <Route path="/newsfeed" element={<NewsFeedWrapper />} />
               <Route path="/create-newsfeed" element={<CreateNewsFeed />} />
               <Route path="/permissions" element={<PermissionsWrapper />} />
               <Route path="/roles" element={<RolesWrapper />} />
               <Route path="/create-role-table" element={<CreateRoles />} />
               <Route path="/users" element={<UsersWrapper />} />
               <Route path="/create-user" element={<CreateUsersWrapper />} />
               <Route path="/otp" element={<OtpVerifyWrapper/>}/>
               <Route path="/forget-password" element={<ForgetPasswordWrapper/>}/>
               <Route path="/reset-password" element={<ResetPasswordWrapper/>}/>
          </Routes>
     );
}
